import { Box, colors, Paper, styled, SxProps, Tabs, Typography, useTheme } from "@mui/material";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";

export const Root = styled("div", { label: "machine_more-Page" })
    (({ theme }) => ({
        display: "flex",
        flex: 1,
        flexDirection: "column",
        width: '100%',
    }))

export const Content = styled("div", { label: "machine_more-content" })(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    '.MuiTabs-root':{
        ".MuiButtonBase-root":{
            color: StyleguideSavioColors.text.grayTitles,
            fontWeight: StyleguideSavioFonts.bold,
           
            "&.Mui-disabled": {
                color: StyleguideSavioColors.lightGrey
            },
            "&.Mui-selected": {
                opacity: 1,
                color: StyleguideSavioColors.blue,
            },

            "&:not(.Mui-disabled):hover":{color: StyleguideSavioColors.blue,}
        }
    }
}));

export const MachineMoreBar = styled(Paper, { label: "machine_more-Bar" })
    (({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        width: "100%",
        borderRadius: 0,
        borderBottom: "1px solid " + StyleguideSavioColors.lightGrey,
        "> div": {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            maxWidth: MiscSavio.maxWidth1500,
            margin: '0 auto',
        }
    }))

export const MachineMoreContainer = styled(Box, { label: "machine_more-Container" })
    (({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        width: '100%',

        "> div": {
            paddingLeft: 10,
            paddingRight: 10,
            maxWidth: "calc(" + MiscSavio.maxWidth1500 + "px + 20px) !important",

            "> div": {
                ">div:last-child": {

                    height: 'calc(100vh - 240px)',
                    width: '100%',

                    "> div": {
                        "> div": {
                            "> div": {
                                ">div": {
                                    paddingBottom: 0,
                                }
                            }
                        }
                    }
                }
            }
        }

    }))

export const MachineMoreTypography = styled(Typography, { label: "machine_more-Typography" })
    (({ theme }) => ({
        display: "flex",
        alignItems: "center",
        fontWeight: StyleguideSavioFonts.bold,
        fontSize: 20,
        color: StyleguideSavioColors.text.grayTitles,
        padding: 6,

        "svg": {
            marginRight: 8,
            fontSize: 28,
            color: StyleguideSavioColors.grayBreadcrumb,
            '&:hover':{
                color: StyleguideSavioColors.grayBreadcrumb,
            }
        }
    }))

export const SectionTabs = styled(Tabs, { label: "machine_more-Typography" })
    (({ theme }) => ({

    }))

export const TabsContent = styled(Box, { label: "machine_more-Container" })
    (({ theme }) => ({
        display: "flex",
        height: 'calc(100vh - 200px)',

        "> .MuiBox-root": {
            position: 'relative',
            "> .MuiBox-root": {
                height: '100%',
                "> .MuiBox-root": {
                    height: 'calc(100% - 42px)',

                    "[role='presentation']": {
                        position: "fixed",
                        left: 0,
                        bottom: 85,
                    }
                }
            }
        },
        "table tbody svg": { fontSize: 26 + "px !important", marginTop: 5, },
        ".technicalInfo ": {
            "svg:not(button svg)": {
                marginTop: 0,
                marginRight: 6,
            },
            "td": {
                "> div": {
                    alignItems: 'center',
                }
            }
        },
       
    }))

export const useClasses = () => {
    const theme = useTheme();

    const classes = {
        tabs: {
            display: "flex",
            width: 1 / 1,
            padding: 0,
            minHeight: 0,
            backgroundColor: "#fff",
            borderBottom: '1px solid' + StyleguideSavioColors.lightGrey,

            "button": { paddingTop: "10px", },
            "svg": {
                marginTop: "-3px",
            },


            
                "&::before, &::after": {
                    content: "'/'",
                    position: "absolute",
                    fontSize: 37,
                    
                    top: -6,
                    color: StyleguideSavioColors.lightGrey,
                   
                },
                "&::before":{
                    left: "calc(33.3% - 8px)",
                },
                "&::after":{
                    right: "calc(33.3% - 8px)",
                }
        


        } as SxProps,

        tab: {
            flex: 1,
            flexGrow: 1,
            minHeight: 44,
            fontWeight: StyleguideSavioFonts.medium,
            color: StyleguideSavioColors.text.black,
            overflow: 'visible',
            maxWidth: "none",
            position: 'relative',
           

            "&.Mui-selected": {
                color: StyleguideSavioColors.blue,
            },
            "&.Mui-disabled": {
                color:StyleguideSavioColors.lightGrey,
            },
            "&:hover":{
                color: StyleguideSavioColors.blue,
            },


            "&:nth-of-type(1)":{
                marginRight: "8px",
            },
            "&:nth-of-type(2)":{
                marginLeft: "8px",
                marginRight: "8px",
            },
            "&:nth-of-type(3)":{
                marginLeft: "8px",
            },
        } as SxProps,

        iconSize: {
            fontSize: 26 + "px !important",
            marginTop: '11px',
        }
    };

    return classes;
}